import { useDraftStore } from '@/lib/draftStore';
import { FormField } from '@/components/ui/FormField';
import { TagPicker } from '../TagPicker';

export const Step4Tags = () => {
  const tags = useDraftStore((s) => s.draft.tags);
  const update = useDraftStore((s) => s.update);

  return (
    <FormField
      label="Категории"
      required
      hint={`Выбери от 1 до 3 · ${tags.length} / 3`}
    >
      <TagPicker selected={tags} onChange={(t) => update({ tags: t })} />
    </FormField>
  );
};

export const validateStep4 = (draft: { tags: string[] }): string | null => {
  if (draft.tags.length === 0) return 'Выбери хотя бы один тег';
  return null;
};